import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'reminderSuggestionFilter',
})
export class reminderSuggestionFilter implements PipeTransform {
  transform(items: any[], filter_list: any[]): any {
    let item_list = [];
    items.forEach((element) => {
      if (filter_list.findIndex((x) => x.suggestion_type == element.object_config.type.toLocaleLowerCase()) == -1) {
        item_list.push(element);
      }
    });
    return item_list;
  }
}
